import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../i18n/LanguageProvider';
import LanguageSwitcher from './LanguageSwitcher';

const Header: React.FC = () => {
  const { t } = useTranslation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header className="bg-sand border-b border-slate/10 sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4 md:py-6">
          <div className="flex items-center">
            <Link to="/" className="text-2xl md:text-3xl font-bold text-navy font-space hover:text-navy/80 transition-colors">
            AgentTailor.ai
            </Link>
          </div>
          <nav className="hidden md:flex items-center space-x-6">
            <Link to="/services" className="text-slate hover:text-navy transition-colors duration-200">
              {t('nav.services')}
            </Link>
            <Link to="/case-studies" className="text-slate hover:text-navy transition-colors duration-200">
              {t('nav.caseStudies')}
            </Link>
            <Link to="/mailing" className="text-slate hover:text-navy transition-colors duration-200">
              {t('nav.mailing')}
            </Link>
            <Link to="/about" className="text-slate hover:text-navy transition-colors duration-200">
              {t('nav.about')}
            </Link>
            <Link to="/contact" className="text-slate hover:text-navy transition-colors duration-200">
              {t('nav.contact')}
            </Link>
            <LanguageSwitcher />
            <Link 
              to="/contact"
              className="bg-sky text-navy px-4 py-2 rounded-lg font-medium hover:bg-sky/90 transition-colors duration-200"
            >
              {t('nav.cta')}
            </Link>
          </nav>
          <div className="md:hidden flex items-center space-x-4">
            <LanguageSwitcher />
            <button 
              onClick={toggleMobileMenu} 
              className="text-navy p-2 focus:outline-none"
              aria-label="Toggle menu"
            >
              {mobileMenuOpen ? (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              ) : (
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              )}
            </button>
          </div>
        </div>
        
        {/* Mobile menu dropdown */}
        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-slate/10">
            <div className="flex flex-col space-y-4">
              <Link 
                to="/services" 
                className="text-slate hover:text-navy transition-colors duration-200 px-2 py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                {t('nav.services')}
              </Link>
              <Link 
                to="/mailing" 
                className="text-slate hover:text-navy transition-colors duration-200 px-2 py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                {t('nav.mailing')}
              </Link>
              <Link 
                to="/case-studies" 
                className="text-slate hover:text-navy transition-colors duration-200 px-2 py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                {t('nav.caseStudies')}
              </Link>
              <Link 
                to="/about" 
                className="text-slate hover:text-navy transition-colors duration-200 px-2 py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                {t('nav.about')}
              </Link>
              <Link 
                to="/contact" 
                className="text-slate hover:text-navy transition-colors duration-200 px-2 py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                {t('nav.contact')}
              </Link>
              <Link 
                to="/contact"
                className="bg-sky text-navy px-4 py-2 rounded-lg font-medium hover:bg-sky/90 transition-colors duration-200 w-full text-center"
                onClick={() => setMobileMenuOpen(false)}
              >
                {t('nav.cta')}
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;